// Definição para o modal de busca de Operações de Financiamento
// Factory function - recebe filtros como parâmetros, sem magic strings

export const criarConfigBuscaOperacaoFinanciamento = (idOrganizacao, idInstituicaoFinanceira = null) => {
  const filtros = { idOrganizacao }
  if (idInstituicaoFinanceira) {
    filtros.idInstituicaoFinanceira = idInstituicaoFinanceira
  }

  return {
    label: 'Financiamento',
    placeholder: 'ID do Financiamento...',
    titulo: 'Selecionar Financiamento Protegido',
    endpointApi: 'OperacoesFinanciamentos',
    idField: 'idOperacaoFinanciamento',
    displayField: 'idOperacaoFinanciamento',
    descField: 'observacaoLivre',
    camposFiltro: [
      { label: 'Busca', model: 'busca', tipo: 'text' }
    ],
    colunasGrid: [
      { header: 'ID', dataField: 'idOperacaoFinanciamento', width: '10%' },
      { header: 'Valor Financiado', dataField: 'valorFinanciado', width: '25%', tipo: 'moeda' },
      { header: 'Moeda', dataField: 'lstMoeda', width: '15%' },
      { header: 'Data Fechamento', dataField: 'dataFechamento', width: '20%', tipo: 'date' },
      { header: 'Status', dataField: 'lstStatusFinanciamento', width: '30%' }
    ],
    filtrosFixos: filtros
  }
}
